import { Box, Button, Grid, IconButton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import DisplayEmptyListAction from "../../../../../../components/DisplayEmptyListAction";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { TDadosPropriedade } from ".";

export default function DisplayListPropriedades({
    items,
    handleOpenDialog,
    handleDeleteItem,
    handleEditItem,
    emptyListMessage,
    linkButtonText,
    linkButtonIcon,
    errorMessage = undefined
}: DisplayListPropriedadesProps) {

    const paddingStyle = { paddingLeft: 0, paddingRight: 0 };

    return (
        <>
            <Grid size={{xs: 12}} my={1}>
                <Stack
                    direction={"row"}
                    alignItems={"flex-start"}
                    justifyContent={"space-between"}
                >
                    <Typography variant="subtitle1" fontWeight={600}>
                        Fazendas
                    </Typography>
                    {items.length > 0 && (
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={handleOpenDialog}
                            startIcon={linkButtonIcon}
                            sx={{ textTransform: "none", paddingX: 3 }}
                        >
                            Adicionar
                        </Button>
                    )}
                </Stack>
            </Grid>
            {items.length > 0 && (
                <Grid size={{xs: 12}}>
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={paddingStyle}>
                                        <b>Nome</b>
                                    </TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {items.map((item, index) => (
                                    <TableRow
                                        key={index}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell sx={paddingStyle}>{item.nome}</TableCell>
                                        <TableCell sx={paddingStyle}>
                                            <Box
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="flex-end"
                                            >
                                                {handleEditItem && (
                                                    <IconButton
                                                        aria-label="edit"
                                                        onClick={() => handleEditItem(item, index)}
                                                    >
                                                        <EditIcon />
                                                    </IconButton>
                                                )}
                                                <IconButton
                                                    aria-label="delete"
                                                    onClick={() => handleDeleteItem(index)}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            )}
            {items.length <= 0 && (
                <Grid size={{xs: 12}}>
                    <DisplayEmptyListAction
                        label={emptyListMessage}
                        actionSection={
                            <Stack direction="column" gap={2}>
                                <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={linkButtonIcon}
                                    onClick={handleOpenDialog}
                                    sx={{ mt: 1, textTransform: "none", paddingX: 3 }}
                                >
                                    {linkButtonText}
                                </Button>
                                {errorMessage && (
                                    <Typography variant="body2" color="error">
                                        {errorMessage}
                                    </Typography>
                                )}
                            </Stack>
                        }
                    />
                </Grid>
            )}
        </>
    );
}

interface DisplayListPropriedadesProps {
    items: TDadosPropriedade[];
    handleOpenDialog: () => void;
    handleDeleteItem: (id: number) => void;
    handleEditItem: (item: TDadosPropriedade, index: number) => void;
    emptyListMessage: string;
    linkButtonText: string;
    linkButtonIcon: React.ReactNode;
    errorMessage?: string;
}
